import floor from 'lodash/floor'
import { Maybe } from 'types/graphqlTypes'
import { TTierNumber } from '../types'
import { getTierRange } from './getTierRange'

export interface IGetActiveCommissionTierProps {
  rate?: Maybe<number>
  tier1Max?: number
  tier2Max?: number
  tier3Max?: number
}

/**
 * Returns the active tier number based on max threshold values and rate
 * @example getActiveCommissionTier({ rate: 1150, tier1Max: 1100, tier2Max: 1250, tier3Max: 1350 }) // 2
 */
export const getActiveCommissionTier = ({
  rate,
  tier1Max = 0,
  tier2Max = 0,
  tier3Max = 0,
}: IGetActiveCommissionTierProps): Maybe<TTierNumber> => {
  if (!rate) {
    return null
  }

  const tier2Range = getTierRange({ tierNumber: 2, tier1Max, tier2Max, tier3Max })
  const tier3Range = getTierRange({ tierNumber: 3, tier1Max, tier2Max, tier3Max })
  const tier4Range = getTierRange({ tierNumber: 4, tier1Max, tier2Max, tier3Max })

  const { min: tier2Min } = tier2Range || {}
  const { min: tier3Min } = tier3Range || {}
  const { min: tier4Min } = tier4Range || {}

  if (!tier2Min || !tier3Min || !tier4Min) {
    return null
  }

  const roundedRate = floor(rate, 2)

  if (roundedRate >= floor(tier4Min, 2)) {
    return 4
  }
  if (roundedRate >= floor(tier3Min, 2) && roundedRate <= floor(tier3Max, 2)) {
    return 3
  }
  if (roundedRate >= floor(tier2Min, 2) && roundedRate <= floor(tier2Max, 2)) {
    return 2
  }
  return 1
}
